import { Injectable } from '@angular/core';

import { BaseGetProvider, DataTransformationProtocol } from '@tendercuts/http';
import { Complaint } from '@tendercuts/models';

import { HttpClient, HttpParams } from '@angular/common/http';
import { EndPoint } from '@endpoint';
import { LoginServices } from '@login';

@Injectable()
export class CustomerComplainsService extends BaseGetProvider<Complaint>
  implements DataTransformationProtocol {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices,
  ) {
    super(http);
    this.delegate = this;
  }

  // override this
  preProcessResponse(response: any): Array<any> {
    return response.results;
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof Complaint {
    return Complaint;
  }

  get endpoint(): string {
    return this.endpointService.customerComplains();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(userId: string): HttpParams {
    let params: HttpParams = new HttpParams();
    params = params.append('customer_id', userId.toString());

    return params;
  }
}
